/* eslint-disable @typescript-eslint/no-explicit-any */

import { formatDateShortWeekday } from '@/app/components/search/utils/dates/utilDates';
import { isUsLocale } from '@/app/common/measures/locale.ts';

export default class WeekModel {
  private readonly locale: string;
  private readonly lang: string;

  constructor(props: { locale: string; lang: string }) {
    const { locale, lang } = props;

    this.locale = locale;
    this.lang = lang;
  }

  get weekDays(): string[] {
    const { locale, lang } = this;

    if (lang === 'PT') {
      return ['Seg.', 'Ter.', 'Qua.', 'Qui.', 'Sex.', 'Sáb.', 'Dom.'];
    }

    let day = isUsLocale(locale) ? 4 : 5;
    const weekDays: any = [];
    for (let i = 0; i < 7; i += 1) {
      weekDays.push(formatDateShortWeekday(locale, `1977-12-${day}`).replace('.', ''));
      day += 1;
    }
    return weekDays;
  }
}
